import { makeStyles } from '@material-ui/core/styles'
import { rgba } from 'polished'
import { IStyleProps } from './Interface'

export default makeStyles<{}, IStyleProps>({
  root: {
    textAlign: 'center'
  },
  avatarContainer: {
    position: 'relative',
    borderRadius: '50%',
    overflow: 'hidden',
    display: 'inline-block',
    '&:hover $remove': {
      display: 'flex'
    }
  },
  avatar: {
    width: 200,
    height: 200,
    fontSize: 70,
    background: '#7647B2'
  },
  remove: {
    left: '50%',
    bottom: 0,
    height: 70,
    width: '100%',
    position: 'absolute',
    transform: 'translateX(-50%)',
    cursor: 'pointer',
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: rgba(0, 0, 0, 0.3),
    borderRadius: '0 0 50px 50px '
  }
})
